<template>
  <!-- 分页获取sku编码 -->
  <div>
    <Row :gutter="20">
      <!-- <Col span="9">
        <Input
          v-model="params.brandCode"
          placeholder="请选择品牌"
          class="search"
        />
      </Col>
      <Col span="9">
        <Input v-model="params.name" placeholder="请输入名称" class="search" />
      </Col>
      <Col span="6">
        <Button type="primary" @click="getList">搜索</Button>
        <Button @click="resetList">重置</Button>
      </Col> -->
      <Col span="24" style="margin-top: 16px">
        <Table
          class="table"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="SKUList.data || []"
          @on-selection-change="onChange"
        ></Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="SKUList.total"
          show-sizer
          show-total
          prev-text="上一页"
          next-text="下一页"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
      <Col span="24" style="margin-top: 20px; text-align: right">
        <Button type="primary" @click="selecthandler">确认</Button>
        <Button @click="cancelhandler">取消</Button>
      </Col>
    </Row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: " ",
    type: "selection",
    width: 50,
  },
  {
    title: "SKU编码",
    key: "code",
  },
  {
    title: "名称",
    key: "name",
  },
  {
    title: "品牌名称",
    key: "brandName",
  },
  {
    title: "创建时间",
    key: "createtime",
  },
];
const params = {
  page: 1,
  pageSize: 10,
};
export default {
  prop: ["select", "onSelect", "onCancel"],
  data() {
    return {
      params,
      columns,
      value: [],
      page: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters("stageInfo", {
      SKUList: "getSKUList",
    }),
  },
  watch: {
    SKUList: {
      deep: true,
      handler: function (newv, old) {
        if (newv && newv.data) {
          (newv.data || []).forEach((sku) => {
            (this.page[this.params.page] || []).forEach((select) => {
              if (select.code === sku.code) {
                sku["_checked"] = true;
              }
            });
          });
        }
      },
    },
  },
  created() {
    this.page = this.select || {};
    this.load();
  },
//   mounted(){
//       this.page = this.select || {};
//       this.load();
//   },
  methods: {
    load() {
      this.loading = true;
      this.$store.dispatch("stageInfo/getSKUList", this.params).finally(() => {
        this.loading = false;
      });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.page = pageNum;
      this.load();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.page == 1) {
        this.load();
      } else {
        this.params.page = 1;
      }
    },
    onChange(selection) {
      this.page[this.params.page] = selection;
    },
    selecthandler() {
      this.$emit("onSelect", this.page);
    },
    cancelhandler() {
      this.$emit("onCancel");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/sku/list.vue